import colors from 'styles/sass-variables.module.scss';

const wrapper = {
  maxWidth: '700px',
  width: '100%',
  padding: '0',
};

const page: Record<string, string> = {
  margin: '0',
  boxSizing: 'border-box',
  backgroundColor: colors.page_background,
};

const contentWrapper: Record<string, string> = {
  boxSizing: 'border-box',
  padding: '50px 0',
  margin: '0 auto',
  maxWidth: '986px',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
};

const styles = {
  page,
  contentWrapper,
  wrapper,
};

export default styles;
